module.exports = __webpack_public_path__ + "static/media/rcs.0ebdf83b.png";